module.exports = __webpack_public_path__ + "img/kontakta oss.0ceca6dd.jpg";